(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('UserActivationDeleteController',UserActivationDeleteController);

    UserActivationDeleteController.$inject = ['$uibModalInstance', 'entity', 'UserActivation'];

    function UserActivationDeleteController($uibModalInstance, entity, UserActivation) {
        var vm = this;

        vm.userActivation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UserActivation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
